import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/Logo nova.png'
import _imports_1 from '@/assets/Logo nova.png'


const _hoisted_1 = { class: "min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-100 to-gray-200 p-3 sm:p-4 md:p-6" }
const _hoisted_2 = { class: "w-full max-w-6xl" }
const _hoisted_3 = { class: "bg-white backdrop-blur-xl rounded-xl sm:rounded-2xl md:rounded-3xl shadow-2xl overflow-hidden border border-gray-200" }
const _hoisted_4 = { class: "flex flex-col lg:flex-row" }
const _hoisted_5 = { class: "w-full lg:w-1/2 p-4 sm:p-6 md:p-8 lg:p-12 xl:p-16 flex flex-col justify-center bg-white" }
const _hoisted_6 = { class: "max-w-md mx-auto w-full" }
const _hoisted_7 = {
  key: 0,
  class: "mb-3 sm:mb-4 p-2.5 sm:p-3 bg-red-50 border border-red-200 rounded-lg flex items-start"
}
const _hoisted_8 = { class: "text-xs sm:text-sm text-red-700" }
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = { class: "relative" }
const _hoisted_11 = {
  key: 0,
  class: "mt-1 text-xs sm:text-sm text-red-600"
}
const _hoisted_12 = { class: "relative" }
const _hoisted_13 = { class: "relative" }
const _hoisted_14 = ["type"]
const _hoisted_15 = {
  key: 0,
  class: "w-4 h-4 sm:w-5 sm:h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_16 = {
  key: 1,
  class: "w-4 h-4 sm:w-5 sm:h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_17 = {
  key: 0,
  class: "mt-1 text-xs sm:text-sm text-red-600"
}
const _hoisted_18 = { class: "flex items-center justify-end pt-1" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_21 = {
  key: 1,
  class: "flex items-center justify-center"
}

import { ref } from "vue";
import { useRouter } from "vue-router";
import { useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/yup";
import * as yup from "yup";
import { useAuthStore } from "@/stores/authStore";
import { AxiosError } from "axios";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const router = useRouter();
const authStore = useAuthStore();

const loginSchema = toTypedSchema(
  yup.object({
    email: yup
      .string()
      .trim()
      .required("Por favor completa todos los campos"),
    password: yup
      .string()
      .required("Por favor completa todos los campos"),
  })
);

const { defineField, handleSubmit, errors } = useForm({
  validationSchema: loginSchema,
  initialValues: {
    email: "",
    password: "",
  },
});

const [email] = defineField("email");
const [password] = defineField("password");

const showPassword = ref(false);
const focusedInput = ref("");
const errorMessage = ref("");

const onLogin = handleSubmit(async (values) => {
  errorMessage.value = "";

  try {
    await authStore.login(values.email, values.password);

    router.push("/dashboard");
  } catch (error: any) {
    // El authStore puede lanzar un error con formato {status, message}
    if (error && typeof error === 'object' && 'message' in error) {
      const message = error.message;
      
      // Si el mensaje es un array, unirlo con saltos de línea
      if (Array.isArray(message)) {
        errorMessage.value = message.join('\n');
      } else if (typeof message === 'string') {
        errorMessage.value = message;
      } else {
        errorMessage.value = "Error al iniciar sesión. Inténtalo de nuevo.";
      }
    } else if (error instanceof AxiosError) {
      if (error.response && error.response.data) {
        // El backend envuelve la respuesta en {data, message, status}
        const responseData = error.response.data;
        const message = responseData.message || responseData.error;
        
        // Si el mensaje es un array, unirlo con saltos de línea
        if (Array.isArray(message)) {
          errorMessage.value = message.join('\n');
        } else if (typeof message === 'string') {
          errorMessage.value = message;
        } else {
          errorMessage.value = "Error al iniciar sesión. Inténtalo de nuevo.";
        }
      } else if (error.request) {
        // No se recibió respuesta del servidor
        errorMessage.value =
          "No se pudo conectar con el servidor. Verifica tu conexión a internet.";
      } else {
        // Error en la configuración de la petición
        errorMessage.value = "Ocurrió un error al procesar la solicitud.";
      }
    } else {
      // Error desconocido
      errorMessage.value = "Ocurrió un error inesperado. Inténtalo de nuevo.";
    }
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[21] || (_cache[21] = _createStaticVNode("<div class=\"hidden lg:flex lg:w-1/2 p-8 md:p-12 lg:p-16 flex-col items-center justify-center bg-gradient-to-br from-gray-50 via-white to-gray-100 relative overflow-hidden\" data-v-600b8e60><div class=\"absolute inset-0 opacity-30\" data-v-600b8e60><div class=\"absolute top-10 left-10 w-40 h-40 bg-red-400 rounded-full blur-3xl\" data-v-600b8e60></div><div class=\"absolute bottom-10 right-10 w-60 h-60 bg-red-500 rounded-full blur-3xl\" data-v-600b8e60></div><div class=\"absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-gray-300 rounded-full blur-3xl\" data-v-600b8e60></div></div><div class=\"relative z-10 w-full h-full flex items-center justify-center\" data-v-600b8e60><img src=\"" + _imports_0 + "\" alt=\"Nova Logo\" class=\"w-full h-auto max-w-md px-8 transform transition-all duration-500 hover:scale-105\" data-v-600b8e60></div><div class=\"absolute bottom-8 left-1/2 transform -translate-x-1/2 flex gap-2\" data-v-600b8e60><div class=\"w-2 h-2 bg-gray-600 rounded-full animate-pulse\" data-v-600b8e60></div><div class=\"w-2 h-2 bg-red-500 rounded-full animate-pulse delay-100\" data-v-600b8e60></div><div class=\"w-2 h-2 bg-gray-600 rounded-full animate-pulse delay-200\" data-v-600b8e60></div><div class=\"w-2 h-2 bg-red-500 rounded-full animate-pulse delay-300\" data-v-600b8e60></div></div></div>", 1)),
          _createElementVNode("div", _hoisted_5, [
            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "lg:hidden flex flex-col items-center mb-6 sm:mb-8" }, [
              _createElementVNode("div", { class: "w-32 h-32 sm:w-40 sm:h-40 bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl flex items-center justify-center shadow-xl mb-4 p-4 border-2 border-gray-200" }, [
                _createElementVNode("img", {
                  src: _imports_1,
                  alt: "Nova Logo",
                  class: "w-full h-full object-contain"
                })
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _cache[18] || (_cache[18] = _createElementVNode("h2", { class: "text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-1 sm:mb-2" }, " Bienvenido ", -1)),
              _cache[19] || (_cache[19] = _createElementVNode("p", { class: "text-gray-500 text-xs sm:text-sm md:text-base mb-4 sm:mb-6 md:mb-8" }, " Inicia sesión para continuar ", -1)),
              (errorMessage.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _cache[8] || (_cache[8] = _createElementVNode("svg", {
                      class: "w-4 h-4 sm:w-5 sm:h-5 text-red-500 mr-2 flex-shrink-0 mt-0.5",
                      fill: "currentColor",
                      viewBox: "0 0 20 20"
                    }, [
                      _createElementVNode("path", {
                        "fill-rule": "evenodd",
                        d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                        "clip-rule": "evenodd"
                      })
                    ], -1)),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(errorMessage.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("form", {
                onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_unref(onLogin) && _unref(onLogin)(...args)), ["prevent"])),
                class: "space-y-3 sm:space-y-4 md:space-y-5"
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", { class: "block text-xs sm:text-sm font-semibold text-gray-700 mb-1.5 sm:mb-2" }, [
                    _createTextVNode(" Correo electrónico o nombre de usuario "),
                    _createElementVNode("span", { class: "text-red-500" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 sm:pl-4 flex items-center pointer-events-none" }, [
                      _createElementVNode("svg", {
                        class: "w-4 h-4 sm:w-5 sm:h-5 text-gray-400",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
                        })
                      ])
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(email) ? (email).value = $event : null)),
                      type: "text",
                      onFocus: _cache[1] || (_cache[1] = ($event: any) => (focusedInput.value = 'email')),
                      onBlur: _cache[2] || (_cache[2] = ($event: any) => (focusedInput.value = '')),
                      placeholder: "tu@correo.com o usuario",
                      class: _normalizeClass(["w-full pl-9 sm:pl-11 pr-3 sm:pr-4 py-2.5 sm:py-3 md:py-3.5 text-sm sm:text-base bg-gray-50 border-2 border-gray-200 rounded-lg sm:rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:bg-white focus:border-red-500 transition-all duration-200", {
                        'border-red-500 bg-white':
                          focusedInput.value === 'email' || !!_unref(errors).email,
                      }])
                    }, null, 34), [
                      [_vModelText, _unref(email)]
                    ])
                  ]),
                  (_unref(errors).email)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_unref(errors).email), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", { class: "block text-xs sm:text-sm font-semibold text-gray-700 mb-1.5 sm:mb-2" }, [
                    _createTextVNode(" Contraseña "),
                    _createElementVNode("span", { class: "text-red-500" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_13, [
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 sm:pl-4 flex items-center pointer-events-none" }, [
                      _createElementVNode("svg", {
                        class: "w-4 h-4 sm:w-5 sm:h-5 text-gray-400",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                        })
                      ])
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(password) ? (password).value = $event : null)),
                      type: showPassword.value ? 'text' : 'password',
                      onFocus: _cache[4] || (_cache[4] = ($event: any) => (focusedInput.value = 'password')),
                      onBlur: _cache[5] || (_cache[5] = ($event: any) => (focusedInput.value = '')),
                      placeholder: "••••••••",
                      class: _normalizeClass(["w-full pl-9 sm:pl-11 pr-10 sm:pr-12 py-2.5 sm:py-3 md:py-3.5 text-sm sm:text-base bg-gray-50 border-2 border-gray-200 rounded-lg sm:rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:bg-white focus:border-red-500 transition-all duration-200", {
                        'border-red-500 bg-white':
                          focusedInput.value === 'password' || !!_unref(errors).password,
                      }])
                    }, null, 42, _hoisted_14), [
                      [_vModelDynamic, _unref(password)]
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (showPassword.value = !showPassword.value)),
                      class: "absolute inset-y-0 right-0 pr-3 sm:pr-4 flex items-center text-gray-400 hover:text-gray-600 transition-colors"
                    }, [
                      (!showPassword.value)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_15, [...(_cache[11] || (_cache[11] = [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                            }, null, -1),
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                            }, null, -1)
                          ]))]))
                        : (_openBlock(), _createElementBlock("svg", _hoisted_16, [...(_cache[12] || (_cache[12] = [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                            }, null, -1)
                          ]))]))
                    ])
                  ]),
                  (_unref(errors).password)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_unref(errors).password), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_router_link, {
                    to: "/reset-password",
                    class: "text-xs sm:text-sm font-semibold text-gray-600 hover:text-red-600 transition-colors"
                  }, {
                    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                      _createTextVNode(" ¿Olvidaste tu contraseña? ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("button", {
                  type: "submit",
                  disabled: _unref(authStore).isLoading,
                  class: "w-full bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-bold py-3 sm:py-3.5 md:py-4 px-6 rounded-lg sm:rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none text-sm sm:text-base mt-2"
                }, [
                  (!_unref(authStore).isLoading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, [...(_cache[16] || (_cache[16] = [
                        _createElementVNode("span", null, "INICIAR SESIÓN", -1),
                        _createElementVNode("svg", {
                          class: "w-4 h-4 sm:w-5 sm:h-5 ml-2",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M13 7l5 5m0 0l-5 5m5-5H6"
                          })
                        ], -1)
                      ]))]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_21, [...(_cache[17] || (_cache[17] = [
                        _createElementVNode("svg", {
                          class: "animate-spin h-4 w-4 sm:h-5 sm:w-5 mr-3",
                          viewBox: "0 0 24 24",
                          fill: "none"
                        }, [
                          _createElementVNode("circle", {
                            class: "opacity-25",
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            "stroke-width": "4"
                          }),
                          _createElementVNode("path", {
                            class: "opacity-75",
                            fill: "currentColor",
                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          })
                        ], -1),
                        _createTextVNode(" Iniciando sesión... ", -1)
                      ]))]))
                ], 8, _hoisted_19)
              ], 32)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})